/** Matches backend `NotificationCategories.Admin` (new user, VIP alerts for admins). */
export const NOTIFICATION_CATEGORY_ADMIN = 'Admin';

const TZ_BRASILIA = 'America/Sao_Paulo';

/**
 * Formats notification `createdAt` for the UI. Admin operational alerts use Brasília time
 * so admins see a consistent Brazil-local clock regardless of browser timezone.
 */
export function formatNotificationTimestamp(iso: string, locale: string, category: string): string {
  try {
    const d = new Date(iso);
    const opts: Intl.DateTimeFormatOptions = {
      dateStyle: 'medium',
      timeStyle: 'short',
    };
    if (category === NOTIFICATION_CATEGORY_ADMIN) {
      opts.timeZone = TZ_BRASILIA;
    }
    return new Intl.DateTimeFormat(locale, opts).format(d);
  } catch {
    return iso;
  }
}
